import objectFitImages from 'object-fit-images';
// import * as balanceText from 'balance-text/balancetext';
import {throttle} from 'throttle-debounce';
import fitty from 'fitty';

require('select-woo');

export default {
  init() {
    // JavaScript to be fired on all pages

    /* ------------------------------------------------------------------------
    // Object Fit
    // ------------------------------------------------------------------------ */
    objectFitImages();

    /* ------------------------------------------------------------------------
    // Hamburger Toggle
    // ------------------------------------------------------------------------ */

    $(document).on('opened.zf.offCanvas', '#off-canvas', function() {
      $('#hamburger').addClass('is-active');
    }).on('close.zf.offCanvas', '#off-canvas', function() {
      $('#hamburger').removeClass('is-active');
    });

    /* -------------------- ----------------------------------------------------
    // Balance Text
    // ------------------------------------------------------------------------ */
    // balanceText('.balance-text', {watch: true});

    /* ------------------------------------------------------------------------
    // Notices
    // ------------------------------------------------------------------------ */

    const notices = document.querySelectorAll('.callout.notice.hide');

    // Initially display any notices that have not been dismissed
    displayActiveNotices();

    notices.forEach(function(notice) {
      notice.querySelector('.close-button').
        addEventListener('click', function() {
          const noticeIdNum = notice.id.match(/\d+/)[0]; // Extract numerical ID
          storeDismissedNotice(noticeIdNum);
          notice.classList.add('hide'); // Ensure the notice is hidden
        });
    });

    function storeDismissedNotice(noticeIdNum) {
      let dismissedNotices = getDismissedNotices();
      if (!dismissedNotices.includes(noticeIdNum)) {
        dismissedNotices.push(noticeIdNum);
        const dismissedStr = JSON.stringify(dismissedNotices);
        document.cookie = 'dismissedNotices=' + dismissedStr +
          ';path=/;max-age=31536000'; // Store for 1 year
      }
    }

    function getDismissedNotices() {
      const value = '; ' + document.cookie;
      const parts = value.split('; dismissedNotices=');
      if (parts.length === 2) {
        try {
          return JSON.parse(parts.pop().split(';').shift());
        } catch (e) {
          return [];
        }
      }
      return [];
    }

    function displayActiveNotices() {
      let dismissedNotices = getDismissedNotices();
      notices.forEach(function(notice) {
        const noticeIdNum = notice.id.match(/\d+/)[0]; // Extract numerical ID
        if (!dismissedNotices.includes(noticeIdNum)) {
          notice.classList.remove('hide'); // Show active notices
        }
      });
    }

    /* ------------------------------------------------------------------------
    // Match Height
    // ------------------------------------------------------------------------ */
    $('.action-bar, .action-bar-placeholder').matchHeight({
      byRow: false,
    });

    fitty('.fit');

    /* ------------------------------------------------------------------------
    // Row Block Compensation
    // ------------------------------------------------------------------------ */

    $(window).resize(throttle(250, function() {
      $('.row-block-compensation').each(function() {

        var $columns = $(this).children('.column');
        var lastRowPosition = 0;
        var $lastRowColumns;
        var $otherColumns;

        $columns.each(function() {
          var position = $(this).position().top;
          if (position > lastRowPosition) {
            lastRowPosition = position;
          }
        });

        $lastRowColumns = $columns.filter(function() {
          return ($(this).position().top == lastRowPosition);
        });

        $otherColumns = $columns.filter(function() {
          return ($(this).position().top < lastRowPosition);
        });

        $lastRowColumns.removeClass('column-block');
        $otherColumns.addClass('column-block');
      });
    })).trigger('resize');

    /* ------------------------------------------------------------------------
    // Object Fit
    // ------------------------------------------------------------------------ */
    $('.testimonials').slick({
      autoplay: true,
      autoplaySpeed: 10000,
      dots: true,
      arrows: true,
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      slide: '.testimonial',
      appendDots: $('.slide-m-dots'),
      prevArrow: $('.slide-m-prev'),
      nextArrow: $('.slide-m-next'),
    });

    /* ------------------------------------------------------------------------
    // Modals
    // ------------------------------------------------------------------------ */

    $('.event-description a').modaal({
      type: 'image',
    });

    $('.popup-gallery').modaal({
      type: 'image',
    });

    $('.popup-video').modaal({
      type: 'video',
    });

    $('.popup-inline').modaal({});

    let modal_gform_error = $('.gform_validation_error').
      closest('.modal-outer-container');
    console.log('modal_gform_error', modal_gform_error);
    if (modal_gform_error.length) {
      console.log('attempting to open modal');
      requestAnimationFrame(() => {
        console.log('requestAnimationFrame');
        $('a[href=#' + modal_gform_error.prop('id') + ']').
          first().
          trigger('click');
      });
    }

    /* ------------------------------------------------------------------------
    // Event Tracking
    // ------------------------------------------------------------------------ */

    function gaSendEvent(category, action, label) {
      console.log({
        'category': category,
        'action': action,
        'label': label,
      });

      /*eslint-disable */

      if ('ga' in window) {
        var tracker = ga.getAll()[0];
        if (tracker) {
          tracker.send('event', category, action, label);
        }
      } else {
        console.log(
          'Event tracking is not yet activated. Make sure Google Analytics is setup correctly.');
      }

      /*eslint-enable */
    }

    $(document).on('click', 'a', function() {

      var link = this,
        $link = $(this);

      /* ------------------------------------------------------------------------
      // Outbound Links
      // ------------------------------------------------------------------------*/
      if (link.hostname && (link.hostname !== location.hostname) &&
        !$link.hasClass('popup-video')) {
        gaSendEvent('Outbound Links', 'Click', link.href);
      }

      /* ------------------------------------------------------------------------
      // YouTube Links
      // ------------------------------------------------------------------------*/
      if ($link.hasClass('popup-video')) {
        gaSendEvent('Videos', 'Play', link.href);
      }

      /* ------------------------------------------------------------------------
      // Link Event Tracking
      // ------------------------------------------------------------------------*/
      if ($link.is('[data-event-tracking-label]')) {
        gaSendEvent($link.attr('data-event-tracking-category'),
          $link.attr('data-event-tracking-label'), link.href);
      }

      /* ------------------------------------------------------------------------
      // Mail Links
      // ------------------------------------------------------------------------*/
      if ($link.is('[href^="mailto:"]')) {
        gaSendEvent('Mails', 'Click', link.href.replace(/mailto:/ig, ''));
      }

      /* ------------------------------------------------------------------------
      // Telephone Links
      // ------------------------------------------------------------------------*/
      if ($link.is('[href^="tel:"]')) {
        gaSendEvent('Phone Links', 'Click', link.href.replace(/tel:/ig, ''));
      }

      /* ------------------------------------------------------------------------
      // Share Links
      // ------------------------------------------------------------------------*/
      if ($link.hasClass('addtoany_share')) {
        gaSendEvent('Share Links', 'Click', document.title);
      }

      /* ------------------------------------------------------------------------
      // Document Links
      // ------------------------------------------------------------------------*/
      if ($link.is(
        '[href$=".pdf"],[href$=".doc"],[href$=".docx"],[href$="xls"],[href$="xlsx"]')) {
        var label = (link.hostname && link.hostname !== location.hostname)
          ? link.href
          : ('/' + link.pathname).replace('//', '/');
        var ext = link.href.split('.').pop().toUpperCase();
        gaSendEvent('Downloads', ext, label);
      }

    });

    /* ------------------------------------------------------------------------
    // Select Woo
    // ------------------------------------------------------------------------ */
    $('.select-woo').selectWoo();

    /* ------------------------------------------------------------------------
    // Providers
    // ------------------------------------------------------------------------ */

    $(document).on('click', '[data-provider-name]', function() {
      console.log($(this).attr('data-provider-name'));
      $('.populate-provider-name input').
        val($(this).attr('data-provider-name'));
    });

    $(document).on('click', '[data-provider-location]', function() {
      console.log($(this).attr('data-provider-location'));
      $('.populate-provider-location input').
        val($(this).attr('data-provider-location'));
    });

    $(document).on('click', '[data-provider-id]', function() {
      console.log($(this).attr('data-provider-id'));
      $('.populate-provider-id input').
        val($(this).attr('data-provider-id')).
        change();
    });

    $(document).on('click', '[data-location-id]', function() {
      console.log($(this).attr('data-location-id'));
      $('.populate-location-id input').val($(this).attr('data-location-id'));
    });

    $(document).on('click', '[data-dsp]', function() {
      console.log($(this).attr('data-dsp'));
      $('.populate-dsp input').val($(this).attr('data-dsp'));
    });

    function show_hide_rx_upload() {
      let service = $('#input_6_15');
      let rx = $('#input_6_33');
      let upload_container = $('#field_6_38');
      let upload = $('#input_6_38');

      if (service.val() === 'Imaging' && rx.val() == 'Yes') {
        upload_container.show();
        upload.prop('disabled', false);
      } else {
        upload_container.hide();
        upload.prop('disabled', true);
      }
    }

    $(document).on('change', '#input_6_15', show_hide_rx_upload);

    $(document).on('change', '#input_6_33', show_hide_rx_upload);

    /* ------------------------------------------------------------------------
    // Input Masking
    // ------------------------------------------------------------------------ */
    let masks = $('.input-masking input[type=text]');
    if (masks.length) {
      $(document).ready(function() {
        setTimeout(function() {
          masks.each(function() {
            if ($(this).val()) {
              let mask = $(this);
              setTimeout(function() {
                mask.prev().html('<i>' + mask.val() + '</i>');
              }, 500);
            }
          });
        }, 300);
      });
    }

    let date_fields = $('input.datepicker');
    if (date_fields.length) {
      date_fields.
        removeClass('datepicker').
        removeClass('gform-datepicker').
        removeClass('datepicker_no_icon').
        removeClass('gdatepicker-no-icon').
        removeClass('hasDatepicker').
        mask('99/99/9999');
    }

    /* ------------------------------------------------------------------------
    // DECHO Sticky Footer Fix
    // ------------------------------------------------------------------------ */
    $(document).ready(function() {
      var dechos = $('.DECHO');
      var placeholder = $('.action-bar-placeholder');
      if (dechos.length && placeholder.length) {
        dechos.last().after(placeholder);
      }
    });

    /* ------------------------------------------------------------------------
    // Remove Date Picker from date fields
    // ------------------------------------------------------------------------ */
    /* global gform */
    gform.addFilter('gform_datepicker_options_pre_init',
      // eslint-disable-next-line no-unused-vars
      function(optionsObj, formId, fieldId) {
        optionsObj.suppressDatePicker = true;
        optionsObj.showOn = '';

        return optionsObj;
      });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js